import { fail } from '@/features/menu/utils/product-page-actions';
import { useT } from '@/i18n';
import { inputToMinor, moneyToInput } from '@/utils/money';
import { useRestaurantStore } from '@/stores/restaurant.store';
import { useUnsavedGuard } from '@/hooks/useUnsavedGuard';
import { useEffect, useState } from 'react';
import { BlockFooter, List, ListInput, PageContent } from 'framework7-react';

// ─── Base-price edit form ────────────────────────────────────────────────────

export type PriceSubmit = (price: number, done: () => void, errOut: (e: unknown) => void) => void;

export default function PriceSheetContent({
  open,
  onClose,
  initial,
  onSubmit,
  submitRef,
}: {
  open: boolean;
  onClose: () => void;
  initial: number;
  onSubmit: PriceSubmit;
  submitRef: { current: () => void };
}) {
  const t = useT();
  const currency = useRestaurantStore((s) => s.restaurantConfig?.currency) ?? 'EUR';
  const [value, setValue] = useState('0');
  useEffect(() => {
    if (open) setValue(moneyToInput(initial, currency));
  }, [open, initial, currency]);

  useUnsavedGuard(open && value !== moneyToInput(initial, currency));

  submitRef.current = () => onSubmit(inputToMinor(value, currency), onClose, fail);

  return (
    <PageContent>
      <List strongIos insetIos>
        <ListInput
          label={t.menu.basePrice}
          type="number"
          inputmode="decimal"
          value={value}
          onInput={(e) => setValue((e.target as HTMLInputElement).value)}
        />
      </List>
      <BlockFooter>{t.menu.basePriceFooter}</BlockFooter>
    </PageContent>
  );
}
